import { render } from "./AlignVerticalTop.vue?vue&type=template&id=1576b636"
import script from "./AlignVerticalTop.vue?vue&type=script&lang=js"
export * from "./AlignVerticalTop.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlignVerticalTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1576b636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1576b636', __exports__)) {
    api.reload('1576b636', __exports__)
  }
  
  module.hot.accept("./AlignVerticalTop.vue?vue&type=template&id=1576b636", () => {
    api.rerender('1576b636', render)
  })

}


export default __exports__